export default function Footer() {
  return (
    <footer
      data-testid="wc-footer"
      className="bg-[#1f1740] text-white pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-2">
            <img
              src="/wincampaign-logo.webp"
              alt="WinCampaign"
              className="h-9 w-auto brightness-0 invert"
            />
            <p className="mt-5 max-w-md text-white font-display font-semibold text-lg leading-snug">
              The Done-for-You Business Growth Accelerator for WinCampaign Brand Affiliates.
            </p>
            <p className="mt-4 max-w-md text-white/80 font-display font-semibold">
              We Are Your Dedicated Business Growth Team.
            </p>
            <p className="mt-2 max-w-md text-white/70 leading-relaxed">
              We handle your content marketing, social media consistency, and lead generation — so you can focus on building relationships, closing new subscribers, and achieving your{" "}
              <span className="text-[#d3fc3a] font-semibold">$10K/month recurring income goal</span>.
            </p>
          </div>
          <div>
            <div className="font-display font-semibold mb-4 text-white/90 uppercase tracking-[0.14em] text-xs">
              Quick Links
            </div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>
                <a
                  href="/#top"
                  data-testid="wc-footer-home"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/#pricing"
                  data-testid="wc-footer-pricing"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="mailto:support@wincampaign.io"
                  data-testid="wc-footer-contact"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="font-display font-semibold mb-4 text-white/90 uppercase tracking-[0.14em] text-xs">
              Legal
            </div>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>
                <a
                  href="/privacy-policy"
                  data-testid="wc-footer-privacy"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms-and-conditions"
                  data-testid="wc-footer-terms"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Terms &amp; Conditions
                </a>
              </li>
              <li>
                <a
                  href="/cancellation-billing-policy"
                  data-testid="wc-footer-refund"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Cancellation &amp; Billing Policy
                </a>
              </li>
              <li>
                <a
                  href="/earnings-disclaimer"
                  data-testid="wc-footer-earnings"
                  className="hover:text-[#d3fc3a] transition-colors"
                >
                  Earnings Disclaimer
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 space-y-6">
          <p
            data-testid="wc-footer-disclaimer"
            className="text-xs sm:text-[13px] text-white/50 leading-relaxed max-w-4xl"
          >
            <span className="font-semibold text-white/70">Disclaimer:</span>{" "}
            Any references to building a &ldquo;$10K/month recurring
            business&rdquo; represent aspirational business goals and should
            not be interpreted as guarantees of income or financial results.
            Individual results vary based on many factors, including effort,
            implementation, market conditions, and business experience.
            WinCampaign provides marketing services and business support but
            does not guarantee specific earnings, leads, or business outcomes.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-sm text-white/60 pt-4 border-t border-white/10">
            <div>
              © {new Date().getFullYear()} WinCampaign. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
